module.exports = __webpack_public_path__ + "img/prelogin.a07ac5a4.svg";